import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { INTERFACE_THEME_SEARCH_PARAMS_KEY } from '@unifyapps/network/auth/const';
import { useGlobalAppStateStore } from '../../../../../stores/app/GlobalAppStateStore';
import { useRouter } from '../../../../useRouter';

export function useUpdateThemeForPublicInterface() {
  const router = useRouter();
  const pathname = router.pathname;
  const searchParams = router.searchParams;
  const { setInterfaceThemeId } = useGlobalAppStateStore().hooks.useActions();

  const updateThemeForPublicInterface = useEventCallback(({ themeId }: { themeId: string }) => {
    setInterfaceThemeId(themeId);
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set(INTERFACE_THEME_SEARCH_PARAMS_KEY, themeId);
    const newUrl = `${pathname}?${newSearchParams.toString()}`;
    router.replace(newUrl, true);
    return Promise.resolve();
  });

  return { updateThemeForPublicInterface };
}
